import React, { Suspense, lazy } from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/config/i18n.ts";
import LoaderOverlay from "./features/LoaderOverlay/components/index.tsx";
import Header from "./features/Header/components/index.tsx";
import HeroSection from "./features/HeroSection/components/index.tsx";
import EssentialInfoCardsGroup from "./features/EssentialInfoCardGroup/components/index.tsx";
//import AboutUs from "./features/AboutUs/components/index.tsx";
//import HowItWorks from "./features/HowItWorks/components/index.tsx";
//import OurTeam from "./features/OurTeam/components/index.tsx";
//import PhotoPuzzle from "./Experimental/PhotoPuzzle/index.tsx";
//import ContactForm from "./features/ContactForm/components/index.tsx";
//import ExclusiveContent from "./features/ExclusiveContent/components/index.tsx";
//import OurPhilosophy from "./features/OurPhilosophy/components/index.tsx";
//import Footer from "./features/Footer/components/index.tsx";

//import { ParallaxSliderConfig } from "./features/parallax-slider/types";
//import pizzaData from "./features/resources/Cards/YanaLisovaCard/mockData/pizzas.json";
//import YanaLisovaCard from "./features/resources/Cards/YanaLisovaCard/components";
//import ButtonSweetPunk from "./features/resources/Buttons/ButtonSweetPunk";
//import SlideUpText from "./features/resources/Texts/SlideUpText";
//import TypewriterText from "./features/resources/Texts/TypewriterText";
//import CylinderText from "./features/resources/Texts/CylinderText";
//import NavigatorBar from "./features/resources/Menus/NavigationBar";
//import NewTextOverlap from "./features/resources/Texts/OverlapText"
//import SpinnerDotPulse from "./features/resources/Spinners/SpinnerDotPulse";
//import Marquee from "./features/resources/Marquee";
//import RainingText from "./features/resources/RainingText";
//import TypewriterText from "./features/resources/TypewriterText";
//import ButtonSweetPunk from "./features/resources/ButtonSweetPunk/index";
//import ParallaxSliderContainer from "./features/parallax-slider/containers/ParallaxSliderContainer";
//import imgspinner from "./features/resources/Spinners/SpinnerDotPulseSvg/index.svg"
//import HamburgerButtonJonSuh from "./features/resources/HamburgerButtons/HamburgerButtonJonSuh";
//import HeroSection from "./features/hero-section/components/Main";
//import Main from "./features/hero-section/components/Main";
//import Shakibali778Card from "./features/resources/Cards/Shakibali778Card/components"

const App: React.FC = () => {
	//const [items, setItems] = useState<JSX.Element[]>([]);

	//la animacion interna de parallax debe suspenderse cuando pasa del ultimo al primero
	/* 	const [config, setConfig] = useState({
        distance: 20,
        animationDuration: 1,
        autoPlay: true,
        autoPlayDuration: 3000,
        autoPlayStopOnHover: true,
        allowParallaxEffect: false,
        allowWheel: true,
        allowDrag: true,
        showNavigationButtons: false,
        showNavigationDots: false,
        placeNavigationDotsOnTop: true,
	}); */

	/* useEffect(()=>{
		setItems([img1, img2, img3, img4, img5]);
	},[])

	useEffect(() => {
		// Para simular carga de imágenes con blur
		const images = document.querySelectorAll('img');
		images.forEach(img => {
		  img.style.filter = 'blur(10px)';
		  img.onload = () => {
			// Agregamos un pequeño retraso para hacer el efecto más visible
			setTimeout(() => {
			  img.style.transition = 'filter 0.5s ease-out';
			  img.style.filter = 'blur(0)';
			}, 300);
		  };
		});
	  }, []); */

	
	/* 
	const Header = lazy(() => import("./features/Header/components"));
	const HeroSection = lazy(() => import("./features/HeroSection/components"));
	const EssentialInfoCardsGroup = lazy(() => import("./features/EssentialInfoCardGroup/components")); */
	const AboutUs = lazy(() => import("./features/AboutUs/components"));
	const HowItWorks = lazy(() => import("./features/HowItWorks/components"));
	//const Menu = lazy(() => import("./features/Menu/components"));
	const OurTeam = lazy(() => import("./features/OurTeam/components/index.tsx"));
	const Timeline = lazy(() => import("./features/Timeline/components"));
	const OurProcess = lazy(() => import("./features/OurProcess/components"));
	const Testimonials = lazy(() => import("./features/Testimonials/components"));
	const PhotoPuzzle = lazy(() => import("./Experimental/PhotoPuzzle/index"));
	const Location = lazy(() => import("./features/Location/components"));
	const Video = lazy(() => import("./features/Video/components/index"));
	const Partners = lazy(() => import("./features/Partners/components/index.tsx"));
	//const Partners2 = lazy(() => import("./features/Partners/components/index2.tsx"));
	const OurPhilosophy = lazy(() => import("./features/OurPhilosophy/components/index.tsx"));
	const ContactForm = lazy(() => import("./features/ContactForm/components"));
	const ExclusiveContent = lazy(() => import("./features/ExclusiveContent/components"));
	const Footer = lazy(() => import("./features/Footer/components"));

	//const Modal = lazy(() => import("./features/Resources/components/Modal/index.tsx"));
	//const imgs = ["#1","#2","#3","#4","#5","#6","#7","#8","#9","#10"].map((e,i) => `https://picsum.photos/200/200?random=${i}`);

	return (
		<I18nextProvider i18n={i18n}>
			<Suspense fallback={<p className="flex items-center justify-center text-center w-full h-screen">Loading..</p>}>
				<main className="App flex flex-col gap-20 sm:gap-0 overflow-hidden relative bg-body text-base-color">
					<LoaderOverlay />
					<div className="flex flex-col gap-20 2xl:gap-[6vw]">
						<div>
							<Header />
							<HeroSection />
						</div>
						<EssentialInfoCardsGroup />
						<Suspense fallback={<>Loading..</>}>
							<AboutUs />
						</Suspense>
					</div>

					<div className="flex flex-col gap-30 xl:gap-30 2xl:gap-[13vw]">
						<Suspense fallback={<>Loading..</>}>
							<HowItWorks />
						</Suspense>
						<Suspense fallback={<>Loading..</>}>
							<PhotoPuzzle />
						</Suspense>
						<Suspense fallback={<>Loading..</>}>
							<OurTeam />
						</Suspense>
						<Suspense fallback={<>Loading..</>}>
							<Timeline />
						</Suspense>
						<Suspense fallback={<>Loading..</>}>
							<OurProcess />
						</Suspense>
						<Suspense fallback={<>Loading..</>}>
							<Testimonials />
						</Suspense>
						<Suspense fallback={<>Loading..</>}>
							<OurPhilosophy />
						</Suspense>
						<Suspense fallback={<>Loading..</>}>
							<Partners />
						</Suspense>
						<Suspense fallback={<>Loading..</>}>
							<Video />
						</Suspense>
						<Suspense fallback={<>Loading..</>}>
							<Location />
						</Suspense>
						<Suspense fallback={<>Loading..</>}>
							<ContactForm />
						</Suspense>
						<Suspense fallback={<>Loading..</>}>
							<ExclusiveContent />
						</Suspense>
						<Suspense fallback={<>Loading..</>}>
							<Footer />
						</Suspense>
					</div>

					{/* <HamburgerButtonJonSuh /> */}
					{/* <img src={imgspinner} alt="" /> */}
					{/* <SpinnerDotPulse /> */}
					{/* <NewTextOverlap /> */}
					{/* <NavigatorBar /> */}
					{/* <CylinderText /> */}
					{/* <TypewriterText /> */}
					{/* <SlideUpText text={"texto de prueba"} speedMilliseconds={1000} delayMilliseconds={0} /> */}
					{/* <ButtonSweetPunk /> */}
					{/* <YanaLisovaCard data={pizzaData.pizzas} /> */}

					{/* <ParallaxSliderContainer 
						items={items} 
						configState={{ config, setConfig }}
					/> */}
				</main>
			</Suspense>
		</I18nextProvider>
	);
};

export default App;
